enum SizeExtraEnum {
  XS = "xs",
  XL = "xl",
  FULL = "full"
}
export default SizeExtraEnum;
